module.exports = {
  title: {
    nav: [{
        title: ' Первая страница',
        path: '/homeew'
      },
      {
        title: 'презентация компании',
        path: '/profileew'
      },
      {
        title: 'центр продуктов',
        path: '/productew'
      },
      {
        title: 'оборудование и решения',
        path: '/deviceew'
      },
      {
        title: 'инвестирование',
        path: '/investew'
      },
      {
        title: 'набор талантов',
        path: '/recruitew'
      },
      {
        title: 'отзывы клиента',
        path: '/bbsew'
      },
      {
        title: 'связаться с нами',
        path: '/contactew'
      }
    ]
  },
  images: {
    a00index1_02: require('../img/ew/00index1_02.jpg'),
    a00index1_03: require('../img/ew/00index1_03.jpg'),
    a1_02: require('../img/ew/1_02.jpg'),
    ff_06: require('../img/ew/ff_06.jpg')
  },
  text: {
    top1: 'Сделать стартовой страницей',
    top2: 'Сделать любимой страницей',
	search: 'поиск',
    bott1: 'coryright@2011 CHINA MATERIAL INTERNATIONAL CO., LTD. all rights reserved 京ICP备05044301号'
  }

}



// WEBPACK FOOTER //
// ./src/assets/lang/ew.js